import { useState } from "react";
import axios from "./axios";
import { toast } from "sonner";

export const useFundWallet = () => {
  const [loading, setLoading] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [transactionHistory, setTransactionHistory] = useState([]);

  const fundWallet = async (amount) => {
    const token = localStorage.getItem("arena_xp_token");

    if (!token) {
      toast.error("Authentication token not found. Please login again.");
      return { success: false };
    }

    if (!amount || amount < 500) {
      toast.error("Please enter an amount between 500 and 99,999");
      return { success: false };
    }

    setLoading(true);
    try {
      const response = await axios.post(
        "/audiences/wallet/fund-wallet",
        JSON.stringify({
          amount: parseInt(amount),
        }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Wallet funded successfully!");
        return { success: true, data: response.data };
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fund wallet");
      return { success: false, error };
    } finally {
      setLoading(false);
    }
  };

  const getTransactionHistory = async (filter) => {
    setLoadingHistory(true);
    try {
      const response = await axios.get(
        `/audiences/transaction-history?filter=${filter}`
      );

      if (response.status === 200) {
        setTransactionHistory(response?.data?.data?.transaction_history);
        setLoadingHistory(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response?.data?.message || "Failed to fetch transaction history"
      );
    }
  };

  return {
    fundWallet,
    loading,
    getTransactionHistory,
    transactionHistory,
    setTransactionHistory,
    loadingHistory,
  };
};
